// image icons
import iterior from "../../../assets/interior.png";
import landscape from "../../../assets/lanscape.png";
import estimate from "../../../assets/estimate.png";
import consultation from "../../../assets/consultation.png";

export const we_do_details = [
  {
    icon: iterior,
    title: "Construction Management",
    description:
      "Independent building construnction and home improvement services",
    route: "",
  },
  {
    icon: landscape,
    title: "Maintenance & Repair",
    description:
      "Elevating Systems through Expert Maintenance and Swift Repairs!",
    route: "",
  },
  {
    icon: estimate,
    title: "Design, Planning, Estimate",
    description:
      "Crafting Tomorrow: Unleashing Innovation Through Seamless Design, Meticulous Planning, and Precise Estimation!  ",
    route: "",
  },
  {
    icon: consultation,
    title: "Project Consultation",
    description:
      "Beyond Blueprints: Orchestrating Success with Project Management Mastery and Strategic Consultation Expertise!",
    route: "",
  },
];
